<ion-header>
	<ion-toolbar>
		<ion-title>Create Sheet...</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" color="primary">
				<ion-icon slot="icon-only" name="close-sharp"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<div class="container" *ngrxLet="sheetTemplates$ as sheetTemplates; suspenseTpl: loading">
	<div class="scroll-vertical app-padding">
		<app-heading background="primary-3">Template</app-heading>
		<div class="form-section">
			<div class="form-group">
				<app-item class="rounded-border-box hoverable-element" (click)="selectBlank()">
					<app-item-label>Blank</app-item-label>
					@if (selectedTemplatId === null) {
						<app-svg-icon @enterFade name="checkmark-sharp"></app-svg-icon>
					}
				</app-item>
				@for (template of sheetTemplates; track template.id) {
					<app-item class="rounded-border-box hoverable-element" (click)="selectTemplate(template)">
						<app-item-label>{{ template.name }}</app-item-label>
						@if (selectedTemplatId === template.id) {
							<app-svg-icon @enterFade name="checkmark-sharp"></app-svg-icon>
						}
					</app-item>
				}
			</div>
		</div>
		@if (selectedTemplatId) {
			<div @enterLeaveFast>
				<app-heading class="margin-top" background="primary-3">Schedule Template From</app-heading>
				<div class="form-section">
					<div class="form-group">
						<app-item class="rounded-border-box hoverable-element" [dateChanger]="selectedDate" dateFormat="time" minuteValues="0" alignment="end" (dateChanged)="dateSelected($event)">
							<app-item-label class="no-events validation-label">Start time</app-item-label>
							<app-item-value class="no-events" [value]="selectedDate | isoDateToString: 'HH:mm'" placeholder="HH:mm"></app-item-value>
						</app-item>
					</div>
				</div>
			</div>
		}
	</div>
	<div class="footer-box app-padding">
		<app-button fill="solid" (click)="createSheet()">Create</app-button>
	</div>
</div>
<ng-template #loading>
	<app-spinner class="margin-top"></app-spinner>
</ng-template>